import React from 'react';
import { TextField } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { AutocompleteChangeReason } from '@material-ui/lab/useAutocomplete/useAutocomplete';
import cx from 'classnames';

export function EeAutocomplete(props: {
  disabled?: boolean
  onChange?: (event: any, value: any, reason: AutocompleteChangeReason) => void;
  options: any[];
  groupBy?: (option: any) => string;
  getOptionLabel?: (option: any) => string;
  value: NonNullable<any>;
  getOptionSelected?: (option: any) => boolean;
  width?: number
}) {
  const width = props.width || 325;
  return (
    <div className="position-relative mr-3" style={{ width, display: 'inline-block' }}>
      <Autocomplete
        disabled={props.disabled}
        options={props.options}
        getOptionLabel={props.getOptionLabel}
        value={props.value}
        disableClearable
        onChange={props.onChange}
        groupBy={props.groupBy}
        popupIcon={<ExpandMoreIcon />}
        renderInput={(params: any) => (
          <div className={cx('position-relative selector')} style={{ width }}>
            <TextField
              variant="outlined"
              disabled={props.disabled}
              {...params}
            />
          </div>
        )}
        renderOption={(params: any) => (
          <div className={`${params.isNested ? 'pl-4' : ''} lens-options`}>
            {typeof params === 'string' || params instanceof String
              ? params
              : params.name
            }
          </div>
        )}
        getOptionSelected={props.getOptionSelected}
        classes={{
          popper: 'lens-dropdown-menu',
          paper: 'lens-dropdown-menu-paper',
        }}
      />
    </div>
  );
};
